import { useMutation } from 'react-query';
import {useWordPressStore} from "../../store/wordpress.store";
import {WordpressApi} from "../../api/wordpress.api";

export const useWordPressWhatWeDo = () => {
    const setWhatWeDo = useWordPressStore((state) => state.setWhatWeDo);

    return useMutation(WordpressApi.getWhatWeDo, {
        onSuccess: (data) => {
            setWhatWeDo(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};